module.exports = __webpack_public_path__ + "static/media/timeline-step-6.624b0b72.png";